module.exports = __webpack_public_path__ + "x-red.png?5f406431ec88e58a9a44868389a54b78";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/x-red.png
// module id = 948
// module chunks = 0